/**
 * The dnd5e 5.3 layout (2.G deliverable 3): a pure normalizer to the 5.0–5.2 form, after which
 * the 5.0–5.2 mapper runs unchanged. `attributes.senses.ranges` moves up to `attributes.senses`,
 * and a class's advancement object becomes an array in key order. It edits the bounded copy the
 * mapper owns, never the caller's input.
 */
import { isRec } from './input.js';
export function normalize53(actor) {
    const attributes = isRec(actor.system) ? actor.system.attributes : undefined;
    const senses = isRec(attributes) ? attributes.senses : undefined;
    if (isRec(attributes) && isRec(senses) && Object.hasOwn(senses, 'ranges')) {
        const { ranges, ...rest } = senses;
        attributes.senses = { ...rest, ...(isRec(ranges) ? ranges : {}) };
    }
    for (const item of Array.isArray(actor.items) ? actor.items : []) {
        const system = isRec(item) ? item.system : undefined;
        if (isRec(system) && isRec(system.advancement)) {
            system.advancement = Object.values(system.advancement);
        }
    }
    return actor;
}
//# sourceMappingURL=layout-53.js.map